import { AreaChart, Area, XAxis, YAxis } from 'recharts';
import { cn } from '@/lib/utils';

interface SparklineProps {
  data: number[];
  color?: string;
  className?: string;
}

export function Sparkline({ data, color = 'hsl(var(--primary))', className }: SparklineProps) {
  const mapped = data.map((v) => ({ v }));

  return (
    <span className={cn('inline-block', className)}>
      <AreaChart width={80} height={24} data={mapped}>
        <XAxis dataKey="v" hide />
        <YAxis hide />
        <Area
          type="monotone"
          dataKey="v"
          stroke={color}
          strokeWidth={1.5}
          fill={color}
          fillOpacity={0.15}
          dot={false}
          isAnimationActive={false}
        />
      </AreaChart>
    </span>
  );
}
